import { render, staticRenderFns } from "./enviosFallidos.vue?vue&type=template&id=06a2c07c&"
import script from "./enviosFallidos.vue?vue&type=script&lang=js&"
export * from "./enviosFallidos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports